import React, { useEffect, useState } from 'react'
import TimeoutWarningModal from './TimeoutWarningModal'
import { addEventListeners, removeEventListeners } from './eventListenerUtil'
import { refresh } from '@northfoxgroup/frontend-api-lib'

function TimeoutLogicDialog() {
  const [isWarningModalOpen, setWarningModalOpen] = useState(false)
  const [time, setTime] = useState(false)
  useEffect(() => {
    const createTimeout1 = () =>
      // set time for log out dialog
      setTimeout(() => {
        setWarningModalOpen(true)
      }, 8 * 60 * 60 * 1000)

    // const createTimeout2 = () =>
    //   setTimeout(() => {
    //     // Implement a sign out function here
    //     window.location.href = '/dashboard'
    //   }, 1000)
    let timeout = isWarningModalOpen ? null : createTimeout1()
    setTime(timeout)
    const listener = () => {
      if (!isWarningModalOpen) {
        clearTimeout(timeout)
        timeout = createTimeout1()
      }
    }
    // Initialization
    addEventListeners(listener)

    // Cleanup
    return () => {
      removeEventListeners(listener)
      clearTimeout(timeout)
    }
  }, [isWarningModalOpen])
  return (
    <div>
      {isWarningModalOpen && (
        <TimeoutWarningModal
          isOpen={isWarningModalOpen}
          onRequestClose={async () => {
            await refresh()
            setWarningModalOpen(false)
            clearTimeout(time)
          }}
        />
      )}
    </div>
  )
}

export default TimeoutLogicDialog
